import { esc, q } from '../../shared/dom';
import { t } from '../../shared/i18n';

/** Campo de senha com botão mostrar/ocultar. */
export function passwordField(id: string, labelKey: string, opts: { autocomplete: string; placeholder?: string } ): string {
  return `
    <div class="auth-field">
      <label for="${id}" data-i18n="${labelKey}">${esc(t(labelKey))}</label>
      <div class="pw-wrap">
        <input type="password" id="${id}" autocomplete="${opts.autocomplete}" placeholder="${esc(opts.placeholder ?? '')}" required>
        <button type="button" class="pw-toggle" data-toggle="${id}" aria-label="${esc(t('auth.show'))}">${esc(t('auth.show'))}</button>
      </div>
    </div>`;
}

/** Liga os botões mostrar/ocultar dentro de um container. */
export function bindPasswordToggles(root: HTMLElement): void {
  root.querySelectorAll<HTMLButtonElement>('.pw-toggle').forEach(btn => {
    btn.onclick = () => {
      const input = q<HTMLInputElement>('#' + btn.dataset.toggle, root);
      const show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      btn.textContent = show ? t('auth.hide') : t('auth.show');
      input.focus();
    };
  });
}
